import React, { Component, useState } from 'react'
import { Link } from 'react-router-dom'
import BlockColorPicker from '../BlockColorPicker'
import Hints from 'views/pages/UIElements/Hints'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './styles/styles.css'
import { saveCourseSettings } from 'store/ConfigurationSettings/CourseConfig/actions'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { toggleCourseSettings } from 'store/ConfigurationSettings/CourseConfig/actions'
import { handleColorChange } from 'store/ConfigurationSettings/CourseConfig/actions'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import TextEditor from '../../TextEditor'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'
import { onChangeEmailSubject } from 'store/ConfigurationSettings/CourseConfig/actions'
import { onChangeEmailBody } from 'store/ConfigurationSettings/CourseConfig/actions'
import { onChangeAgreementContent } from 'store/ConfigurationSettings/CourseConfig/actions'

const CourseConfig = (props) => {
  const dispatch = useDispatch()
  const language = props.language?.data
  const courseConfig = props.courseConfig

  const [showReminderEmail, setShowReminderEmail] = useState(false)

  // console.log('props', props)
  // console.log('courseConfig', courseConfig)

  console.log('language', language)

  const onAddChange = (value) => {
    dispatch(onChangeEmailBody(value))
  }

  const changeAgreementContent = (value) => {
    dispatch(onChangeAgreementContent(value))
  }

  const saveSettings = () => {
    dispatch(saveCourseSettings())
      .then(() => {
        toast.success(language?.alerts.settings_saved_succesfully, {
          position: toast.POSITION.TOP_CENTER,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
      .catch(() => {
        toast.error(language?.alerts.failed_to_save_settings, {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
  }
  return (
    <div className='tab-content'>
      <div className='modules-options'>
        <h3>{language?.settings.allow_only_admins}:</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.manager_report.mark_quiz_passed}: </span>
            <Hints message={language?.hints.admin_mark_quiz_passed} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.userAdminMarkQuizPassed === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('userAdminMarkQuizPassed'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.mark_course_complete}: </span>
            <Hints
              className='item'
              message={language?.hints.admin_mark_course_complete}
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.userAdminMarkCourseComplete === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('userAdminMarkCourseComplete'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
      <div className='modules-options'>
        <h3>{language?.settings.allow_area_admin}:</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.create_courses}: </span>
            <Hints message={language?.hints.area_admin_create_course} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={
                courseConfig.userAreaAdminCanCreateCourses === 1 || false
              }
              onChange={() =>
                dispatch(toggleCourseSettings('userAreaAdminCanCreateCourses'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.create_course_groups}: </span>
            <Hints message={language?.hints.area_admin_create_course_group} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={
                courseConfig.userAreaAdminCanCreateCourseGroups === 1 || false
              }
              onChange={() =>
                dispatch(
                  toggleCourseSettings('userAreaAdminCanCreateCourseGroups'),
                )
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
      <div className='modules-options'>
        <h3>{language?.settings.allow_course_managers}:</h3>
        {/* <div className="config-row">
            <div className="with-hint item">
              <span>Create courses: </span>
              <Hints message="By checking this, enables the possibility for Course Manager access to add new courses." />
            </div>
            <label className={`switch config-item ${courseConfig.userCourseManagerCanCreateCourse === 1 ? ' active' : ''}`}>
              <input
                checked={courseConfig.userCourseManagerCanCreateCourse === 1 || false}
                onChange={() => dispatch(toggleCourseSettings('userCourseManagerCanCreateCourse')}
                type="checkbox" />
              <div></div>
            </label>
          </div> */}
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.add_users}: </span>
            <Hints message={language?.hints.course_manager_add_user} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.userCourseManagerCanAddUser === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('userCourseManagerCanAddUser'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.manager_report.edit_users}: </span>
            <Hints message={language?.hints.course_manager_edit_users} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.userCourseManagerCanEditUser === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('userCourseManagerCanEditUser'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
      <div className='modules-options'>
        <h3>{language?.settings.course_options}:</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_redirect_url}</span>
            <Hints message={language?.hints.redirect_url} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableCourseRedirectUrl === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableCourseRedirectUrl'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_generating_certificate}</span>
            <Hints message={language?.hints.generate_certificate} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={
                courseConfig.enableCourseGeneratingCertificate === 1 || false
              }
              onChange={() =>
                dispatch(
                  toggleCourseSettings('enableCourseGeneratingCertificate'),
                )
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.show_past_due_training}</span>
            <Hints message={language?.hints.show_paste_due_training} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={
                courseConfig.enableCourseShowPastDueTrainings === 1 || false
              }
              onChange={() =>
                dispatch(
                  toggleCourseSettings('enableCourseShowPastDueTrainings'),
                )
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_quiz_retake_default}</span>
            <Hints message={language?.hints.quiz_reatake_default} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={
                courseConfig.enableCourseQuizRetakeDefault === 1 || false
              }
              onChange={() =>
                dispatch(toggleCourseSettings('enableCourseQuizRetakeDefault'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Send certificate via Email</span>
            <Hints
              message={
                'When user gets certificated the certificate will be sent via email'
              }
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableEmailCertificate === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableEmailCertificate'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Enable certificate button blinking</span>
            <Hints
              message={"Certificate button blinks to take user's attention"}
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableCertificateBlinking === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableCertificateBlinking'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.default_courses}:</span>
            <Hints message={language?.hints.show_default_language_courses} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.includeDefaultCourses === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('includeDefaultCourses'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='config-row'>
          {!showReminderEmail ? (
            <button
              onClick={() => setShowReminderEmail(true)}
              className='btn btn-info'
            >
              Change Reminder Email
            </button>
          ) : (
            <div className='d-flex flex-column'>
              <span>
                <FontAwesomeIcon icon={faLightbulb} />
                <span className='ml-2'>
                  [courses] will be replaced with actual course's names and
                  links. Do not remove if you want users to see which courses
                  they have to finish.
                </span>
              </span>
              <input
                value={courseConfig?.subject || ''}
                placeholder='Email Subject'
                className='w-100 p-2 my-3'
                style={{ border: '1px solid #cecece' }}
                type='text'
                onChange={(e) => dispatch(onChangeEmailSubject(e.target.value))}
              />
              <TextEditor
                key={1}
                placeholder='Email Body'
                // isOpen={users.isShowingEditMessage}
                textContent={courseConfig.emailBody}
                onChangeText={(e) => onAddChange(e)}
              />
              <div className='d-flex mt-3'>
                <button onClick={saveSettings} className='btn btn-info'>
                  Save
                </button>
                <button
                  onClick={() => setShowReminderEmail(false)}
                  className='btn btn-secondary ml-3'
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='modules-options'>
        <h3>Course Certification Agreement:</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Default | Require Agreement Before Certification: </span>
            <Hints message='This setting defines the default behavior for newly created courses. It can be changed for each course individually too.' />
          </div>
          <label className='custom-toggle'>
            <input
              checked={
                courseConfig.requireAgreementBeforeCertification === 1 || false
              }
              onChange={() =>
                dispatch(
                  toggleCourseSettings('requireAgreementBeforeCertification'),
                )
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <TextEditor
            key={2}
            textContent={courseConfig.agreementContent}
            onChangeText={(e) => changeAgreementContent(e)}
            placeholder='Enter the terms, conditions, or acknowledgment learners must agree to before receiving their certificate.'
            setOptions={{
              buttonList: [
                ['undo', 'redo', 'fontSize', 'formatBlock', 'list'],
                ['bold', 'underline', 'italic', 'link'],
              ],
            }}
          />
        </div>
      </div>
      <div className='modules-options'>
        <h3>{language?.settings.course_status_colors}:</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.general.not_started}</span>
            <Hints message={language?.hints.not_started_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'course'}
              option={'notStarted'}
              optionColor={courseConfig.notStarted}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.general.in_progress}</span>
            <Hints message={language?.hints.in_progress_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'course'}
              option={'inProgress'}
              optionColor={courseConfig.inProgress}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.general.quiz_failed}</span>
            <Hints message={language?.hints.quiz_failed_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'course'}
              option={'quizFailed'}
              optionColor={courseConfig.quizFailed}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.general.validation}</span>
            <Hints message={language?.hints.validation_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'course'}
              option={'validation'}
              optionColor={courseConfig.validation}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.general.completed}</span>
            <Hints message={language?.hints.course_complete_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'course'}
              option={'completed'}
              optionColor={courseConfig.completed}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.groups.expired}</span>
            <Hints message={language?.hints.expired_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'course'}
              option={'expired'}
              optionColor={courseConfig.expired}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.groups.reassigned}</span>
            <Hints message={language?.hints.reassign_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'course'}
              option={'reassigned'}
              optionColor={courseConfig.reassigned}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.general.past_due}</span>
            <Hints
              message={"Assigns a color for the 'Past Due' user course status"}
            />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'course'}
              option={'pastDue'}
              optionColor={courseConfig.pastDue}
              handleColorChange={props.handleColorChange}
            />
          </div>
        </div>
      </div>
      <div className='modules-options'>
        <h3>{language?.settings.main_modules}:</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_learning_plan_module}</span>
            <Hints message={language?.hints.learning_plan_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModuleLearningPlan === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModuleLearningPlan'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_compliance_module}</span>
            <Hints message={language?.hints.compliance_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModuleCompliance === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModuleCompliance'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Enable Development module</span>
            <Hints message={language?.hints.development_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModuleDevelopment === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModuleDevelopment'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>

        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_my_library_module}</span>
            <Hints message={language?.hints.my_library_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModuleLibrary === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModuleLibrary'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_my_report_module}</span>
            <Hints message={language?.hints.my_report_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModuleMyReport === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModuleMyReport'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_manager_report_module}</span>
            <Hints message={language?.hints.manager_report_module} />
          </div>{' '}
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModuleManagerReport === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModuleManagerReport'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_discussions_module}</span>
            <Hints message={language?.hints.discussion_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModuleDiscussion === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModuleDiscussion'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Enable Forms module</span>
            <Hints message={'Enables the Forms module'} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModuleForms === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModuleForms'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Enable Recruitment module</span>
            <Hints message={'Enables the Recruitment module'} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableRecruitment === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableRecruitment'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Enable Public Catalog module</span>
            <Hints message={'Enables the Public Catalog module'} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModulePublicCatalog === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModulePublicCatalog'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>
              {language?.settings
                ? language.settings.enable_all_courses_module ||
                  'Enable Course Catalog module'
                : 'Enable Course Catalog module'}
            </span>
            <Hints message={language?.hints.course_catalog_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableModuleAllCourses === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableModuleAllCourses'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
      <div className='modules-options'>
        <h3>{language?.settings.manager_report_view_by}:</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.courses_tab}</span>
            <Hints message={language?.hints.manager_report_courses} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableCoursesManagerReport === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableCoursesManagerReport'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        {/* <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.groups_tab}</span>
            <Hints message={language?.hints.manager_report_groups} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableGroupsManagerReport === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableGroupsManagerReport'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div> */}
      </div>
      <div className='modules-options'>
        <h3>{language?.settings.other}:</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_welcome_email}</span>
            <Hints message={language?.hints.welome_email_existing_users} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableWelcomeEmail === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableWelcomeEmail'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Notify users via email on Library updates</span>
            <Hints
              message={
                'When enabled, users are sent an email whenever a file or folder they have access to is uploaded or updated in the Library.'
              }
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableLibraryUpdateEmail === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableLibraryUpdateEmail'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>
              Don't send email when a new course is added to course group
            </span>
            <Hints
              message={`Do not send email to users when a new course is added to a course group`}
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.disableEmailNewCourse === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('disableEmailNewCourse'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{'Enable categories tab'}</span>
            <Hints message={language?.hints.categories_tab_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableCategories === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableCategories'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.groups.enable_course_group_checklist}</span>
            <Hints message={language?.hints.course_group_checklist_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableCourseGroupChecklist === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableCourseGroupChecklist'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{'Enable course group chain assignment'}</span>
            <Hints
              message={
                'The next course group is disabled until user completes the prevous one.'
              }
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableReorderCourseGroup === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableReorderCourseGroup'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
          {/* {console.log("settings props", props)} */}
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{'Enable extra user fields'}</span>
            <Hints
              message={`Enables adding fields ${
                language?.general
                  ? language.general.extra_field_1
                  : 'Extra field 1*'
              } and ${
                language?.general
                  ? language.general.extra_field_2
                  : 'Extra field 2*'
              }`}
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableUserExtraFields === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableUserExtraFields'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>
              {language?.manager_report.see_other_users_manager_report}
            </span>
            <Hints
              message={language?.manager_report.see_other_users_manager_report}
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={
                courseConfig.enableUserAppearanceWithSameAccessLevel === 1 ||
                false
              }
              onChange={() =>
                dispatch(
                  toggleCourseSettings(
                    'enableUserAppearanceWithSameAccessLevel',
                  ),
                )
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>
              {language?.manager_report.sort_courses_as_in_learning_plan}
            </span>
            <Hints
              message={
                language?.manager_report.sort_courses_not_checked_alphabetically
              }
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.sortCoursesByOrder === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('sortCoursesByOrder'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>
              {language?.learning_plan.enable_status_labels_learning_plan}
            </span>
            <Hints
              message={language?.hints.status_labels_learning_plan_module}
            />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableStatusLabels === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableStatusLabels'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        {/* <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.enable_knowledge_questions}</span>
            <Hints message={language?.hints.knowledge_questions_module} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableKnowledgeQuestions === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableKnowledgeQuestions'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div> */}
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.courses.enable_checklist_percentage}</span>
            <Hints message={language?.hints['checklist_100%_module']} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableChecklistPercentage === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableChecklistPercentage'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{'Enable External Reports'}</span>
            <Hints message={`Enables user external reports`} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableExternalReports === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableExternalReports'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{'Enable Role Groups'}</span>
            <Hints message={`Enables grouping user roles`} />
          </div>
          <label className='custom-toggle'>
            <input
              checked={courseConfig.enableRoleGroups === 1 || false}
              onChange={() =>
                dispatch(toggleCourseSettings('enableRoleGroups'))
              }
              type='checkbox'
              style={{ display: 'none' }}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
      <div className='col my-4'>
        <SubmitModalButton
          text={language?.general.save}
          customFn={saveSettings}
        />
        <Link to='/dashboard'>
          <CancelModalButton text={language?.general.cancel} />
        </Link>
      </div>
      <ToastContainer />
    </div>
  )
}

export default CourseConfig
